// Funciones de conductores: licencias, exámenes, capacitaciones, aptitudes y revisiones.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { db } from "@/firebase";
import { query, collection, where, getDocs, limit, orderBy } from "firebase/firestore";
import localforage from "localforage";
import moment from "moment";
import _ from "lodash";
import { colecciones } from "../constantes";

export const funcionesConductores = {
  // OBTENER CONDUCTORES
  async obtenerConductores(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.conductores.registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    const registros = await Promise.all(
      querySnapshot.docs.map(async (doc) => {
        return await this.obtenerConductorInspeccion(
          idEmpresaSeleccionada,
          doc.id,
          doc.data().conRodamiento === "Si" ? true : false,
        );
      }),
    );
    const conductores = registros.filter((item) => item !== null);
    return conductores ? conductores : [];
  },
  // OBTENER LICENCIAS DE CONDUCTORES
  async obtenerLicenciasConductores(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.conductores.licencias.registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // OBTENER EXAMENES DE CONDUCTORES
  async obtenerExamenesConductores(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.conductores.examenes.registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // OBTENER CAPACITACIONES DE CONDUCTORES
  async obtenerCapacitacionesConductores(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.conductores.capacitaciones
          .registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // OBTENER REVISIONES DE CONDUCTORES
  async obtenerRevisionesConductores(idEmpresaSeleccionada) {
    const q = query(
      collection(
        db,
        colecciones.firebase.seguridadVial.conductores.revisiones.registros,
      ),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // OBTENER EXAMEN DEL CONDUCTOR
  async obtenerExamenConductor(id, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.examenes.registros,
      );
      const examen = Array.isArray(registros)
        ? registros.find((item) => item && item.id === id)
        : null;
      return examen ? examen : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.examenes.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.examenes.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.examenes.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando examen en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerExamenConductor, usando local:", e);
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.conductores.examenes.registros,
        );
        return Array.isArray(registros) ? registros.find((item) => item && item.id === id) || null : null;
      }
    }
  },
  // OBTENER CAPACITACION DEL CONDUCTOR
  async obtenerCapacitacionConductor(id, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.capacitaciones
          .registros,
      );
      const capacitacion = Array.isArray(registros)
        ? registros.find((item) => item && item.id === id)
        : null;
      return capacitacion ? capacitacion : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.capacitaciones
              .registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.capacitaciones.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.capacitaciones.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando capacitacion en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerCapacitacionConductor, usando local:", e);
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.conductores.capacitaciones.registros,
        );
        return Array.isArray(registros) ? registros.find((item) => item && item.id === id) || null : null;
      }
    }
  },
  // OBTENER APTITUD DEL CONDUCTOR
  async obtenerAptitudConductor(id, modoSinConexion) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.aptitudes.registros,
      );
      const aptitud = registros
        ? registros.find((item) => item.id === id)
        : null;
      return aptitud ? aptitud : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.aptitudes.registros,
        ),
        where("id", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER REVISION DEL CONDUCTOR
  async obtenerRevisionConductor(id, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.revisiones
          .registros,
      );
      const revision = Array.isArray(registros)
        ? registros.find((item) => item && item.id === id)
        : null;
      return revision ? revision : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.revisiones.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.revisiones.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.revisiones.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando revision conductor en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerRevisionConductor, usando local:", e);
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.conductores.revisiones.registros,
        );
        return Array.isArray(registros) ? registros.find((item) => item && item.id === id) || null : null;
      }
    }
  },
  // OBTENER CONDUCTOR POR IDUSUARIO
  async obtenerConductorIdUsuario(idUsuario, modoSinConexion) {
    if (modoSinConexion) {
      const conductores = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.registros,
      );
      return conductores
        ? conductores.find((item) => item.idUsuario === idUsuario)
        : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.conductores.registros,
        ),
        where("idUsuario", "==", idUsuario),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER CONDUCTOR POR IDUSUARIO Y IDEMPRESA
  async obtenerConductorIdUsuarioIdEmpresa(idUsuario, idEmpresa) {
    const q = query(
      collection(db, "riskmann_seguridadvial_conductores"),
      where("idUsuario", "==", idUsuario),
      where("idEmpresa", "==", idEmpresa),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs[0].data()
      : null;
  },
  // OBTENER CONDUCTOR POR ID
  async obtenerConductor(id, esEliminado = false, modoSinConexion) {
    if (modoSinConexion) {
      const conductores = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.registros,
      );
      return conductores ? conductores.find((item) => item.id === id) : null;
    } else {
      const estados = esEliminado
        ? ["Creado", "Editado", "Eliminado"]
        : ["Creado", "Editado"];
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.conductores.registros,
        ),
        where("id", "==", id),
        where("registro.estado", "in", estados),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER CONDUCTOR DE INSPECCIÓN (CON RODAMIENTO / SIN RODAMIENTO) - INSPECCIONES
  async obtenerConductorInspeccion(
    idEmpresa,
    idConductor,
    esRodamiento,
    modoSinConexion,
  ) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.registros,
      );
      const conductores = registros
        ? registros.filter((item) => item.id === idConductor)
        : null;
      return conductores ? conductores[0] : null;
    } else {
      if (esRodamiento) {
        const obtenerDatosConductor = await this.obtenerConductor(
          idConductor,
        );
        const obtenerUsuarioConductor =
          obtenerDatosConductor && obtenerDatosConductor.idUsuario
            ? await this.obtenerUsuario(obtenerDatosConductor.idUsuario)
            : null;
        if (obtenerDatosConductor && obtenerUsuarioConductor) {
          let cargo = "SIN CARGO ASIGNADO";
          const obtenerVinculacion = await this.obtenerVinculacion(
            idEmpresa,
            obtenerUsuarioConductor.id,
          );
          if (obtenerUsuarioConductor && obtenerVinculacion) {
            const obtenerCargo = await this.obtenerCargo(
              obtenerVinculacion.idCargo,
            );
            if (obtenerCargo) {
              cargo = obtenerCargo.nombre.toUpperCase();
            }
          }
          return {
            id: idConductor,
            idUsuario: obtenerDatosConductor.idUsuario,
            nombre: `${(obtenerUsuarioConductor.nombre ?? "")
              .toString()
              .toUpperCase()} ${(obtenerUsuarioConductor.apellido ?? "")
                .toString()
                .toUpperCase()}`.trim(),
            numeroIdentificacion: this.ocultarCaracteres(
              (obtenerUsuarioConductor?.documento?.numero ?? "").toString(),
              3,
            ),
            correo: this.ocultarCorreo(
              (obtenerUsuarioConductor?.correo ?? "")
                .toString()
                .toUpperCase(),
            ),
            foto: obtenerUsuarioConductor?.foto?.url || "",
            cargo: cargo,
            conRodamiento: obtenerDatosConductor.conRodamiento,
            dispositivoZonaCliente:
              obtenerDatosConductor.dispositivoZonaCliente
                ? obtenerDatosConductor.dispositivoZonaCliente
                : "-",
            esRodamiento: true,
            vehiculos: obtenerDatosConductor.vehiculos,
          };
        } else {
          return null;
        }
      } else {
        const conductor = await this.obtenerConductor(idConductor);
        if (conductor) {
          return {
            id: conductor.id,
            idUsuario: "",
            nombre: `${(conductor?.sinRodamiento?.nombre ?? "")
              .toString()
              .toUpperCase()} ${(conductor?.sinRodamiento?.apellido ?? "")
                .toString()
                .toUpperCase()}`.trim(),
            numeroIdentificacion: this.ocultarCaracteres(
              (conductor?.sinRodamiento?.documento?.numero ?? "").toString(),
              3,
            ),
            correo: this.ocultarCorreo(
              (conductor?.sinRodamiento?.correo ?? "")
                .toString()
                .toUpperCase(),
            ),
            foto: "",
            cargo: conductor?.sinRodamiento?.cargo || "-",
            conRodamiento: conductor.conRodamiento,
            dispositivoZonaCliente: conductor.dispositivoZonaCliente
              ? conductor.dispositivoZonaCliente
              : "-",
            esRodamiento: false,
            vehiculos: conductor.vehiculos,
          };
        } else {
          return null;
        }
      }
    }
  },
  // OBTENER LICENCIA DEL CONDUCTOR
  async obtenerLicenciaConductor(id, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.licencias.registros,
      );
      const licencia = Array.isArray(registros)
        ? registros.find((item) => item && item.id === id)
        : null;
      return licencia ? licencia : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.licencias.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.licencias.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.licencias.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando licencia en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerLicenciaConductor, usando local:", e);
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.conductores.licencias.registros,
        );
        return Array.isArray(registros) ? registros.find((item) => item && item.id === id) || null : null;
      }
    }
  },
  // OBTENER CONDUCTOR SIN RODAMIENTO POR NUMERO DE IDENTIFICACIÓN
  async obtenerConductorSinRodamientoNumeroIdentificacion(
    idEmpresa,
    numeroIdentificacion,
  ) {
    const q = query(
      collection(db, "riskmann_seguridadvial_conductores"),
      where("idEmpresa", "==", idEmpresa),
      where("conRodamiento", "==", "No"),
      where("sinRodamiento.documento.numero", "==", numeroIdentificacion),
      where("registro.estado", "in", ["Creado", "Editado"]),
      orderBy("registro.creacion", "desc"),
      limit(1),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs[0].data()
      : null;
  },
  // OBTENER LOS DOCUMENTOS MÁS RECIENTES DEL CONDUCTOR
  async obtenerUltimaLicenciaConductor(idConductor, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.licencias.registros,
      );
      const documentos = Array.isArray(registros)
        ? registros
          .filter((item) => item && item.idConductor === idConductor)
          .map((item) => {
            const nuevoItem = { ...item };
            let fechaFormateada = "";
            try {
              if (item.registro && item.registro.creacion) {
                const creacion = item.registro.creacion;
                if (typeof creacion.toDate === "function") {
                  fechaFormateada = moment(creacion.toDate()).format("YYYY-MM-DD HH:mm:ss");
                } else if (creacion.seconds !== undefined) {
                  const fechaRegistro = new Date(creacion.seconds * 1000 + (creacion.nanoseconds || 0) / 1000000);
                  fechaFormateada = moment(fechaRegistro).format("YYYY-MM-DD HH:mm:ss");
                } else {
                  fechaFormateada = moment(creacion).format("YYYY-MM-DD HH:mm:ss");
                }
              }
            } catch (e) {
              fechaFormateada = "";
            }
            if (nuevoItem.registro) {
              nuevoItem.registro = { ...nuevoItem.registro, creacion: fechaFormateada };
            }
            return nuevoItem;
          })
        : [];
      const filtro = _.orderBy(documentos, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.licencias.registros,
          ),
          where("idConductor", "==", idConductor),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.licencias.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.licencias.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando ultima licencia en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimaLicenciaConductor, usando local:", e);
        return await this.obtenerUltimaLicenciaConductor(idConductor, true);
      }
    }
  },
  async obtenerUltimoExamenConductor(idConductor, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.examenes.registros,
      );
      const documentos = Array.isArray(registros)
        ? registros
          .filter((item) => item && item.idConductor === idConductor)
          .map((item) => {
            const nuevoItem = { ...item };
            let fechaFormateada = "";
            try {
              if (item.registro && item.registro.creacion) {
                const creacion = item.registro.creacion;
                if (typeof creacion.toDate === "function") {
                  fechaFormateada = moment(creacion.toDate()).format("YYYY-MM-DD HH:mm:ss");
                } else if (creacion.seconds !== undefined) {
                  const fechaRegistro = new Date(creacion.seconds * 1000 + (creacion.nanoseconds || 0) / 1000000);
                  fechaFormateada = moment(fechaRegistro).format("YYYY-MM-DD HH:mm:ss");
                } else {
                  fechaFormateada = moment(creacion).format("YYYY-MM-DD HH:mm:ss");
                }
              }
            } catch (e) {
              fechaFormateada = "";
            }
            if (nuevoItem.registro) {
              nuevoItem.registro = { ...nuevoItem.registro, creacion: fechaFormateada };
            }
            return nuevoItem;
          })
        : [];
      const filtro = _.orderBy(documentos, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.examenes.registros,
          ),
          where("idConductor", "==", idConductor),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.examenes.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.examenes.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando ultimo examen en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimoExamenConductor, usando local:", e);
        return await this.obtenerUltimoExamenConductor(idConductor, true);
      }
    }
  },
  async obtenerUltimaCapacitacionConductor(idConductor, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.capacitaciones
          .registros,
      );
      const documentos = Array.isArray(registros)
        ? registros
          .filter((item) => item && item.idConductor === idConductor)
          .map((item) => {
            const nuevoItem = { ...item };
            let fechaFormateada = "";
            try {
              if (item.registro && item.registro.creacion) {
                const creacion = item.registro.creacion;
                if (typeof creacion.toDate === "function") {
                  fechaFormateada = moment(creacion.toDate()).format("YYYY-MM-DD HH:mm:ss");
                } else if (creacion.seconds !== undefined) {
                  const fechaRegistro = new Date(creacion.seconds * 1000 + (creacion.nanoseconds || 0) / 1000000);
                  fechaFormateada = moment(fechaRegistro).format("YYYY-MM-DD HH:mm:ss");
                } else {
                  fechaFormateada = moment(creacion).format("YYYY-MM-DD HH:mm:ss");
                }
              }
            } catch (e) {
              fechaFormateada = "";
            }
            if (nuevoItem.registro) {
              nuevoItem.registro = { ...nuevoItem.registro, creacion: fechaFormateada };
            }
            return nuevoItem;
          })
        : [];
      const filtro = _.orderBy(documentos, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.capacitaciones
              .registros,
          ),
          where("idConductor", "==", idConductor),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.capacitaciones.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.capacitaciones.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando ultima capacitacion en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimaCapacitacionConductor, usando local:", e);
        return await this.obtenerUltimaCapacitacionConductor(idConductor, true);
      }
    }
  },
  async obtenerUltimaRevisionConductor(idConductor, modoSinConexion) {
    if (modoSinConexion || !navigator.onLine) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.conductores.revisiones
          .registros,
      );
      const revisiones = Array.isArray(registros)
        ? registros
          .filter((item) => item && item.idConductor === idConductor)
          .map((item) => {
            const nuevoItem = { ...item };
            let fechaFormateada = "";
            try {
              if (item.registro && item.registro.creacion) {
                const creacion = item.registro.creacion;
                if (typeof creacion.toDate === "function") {
                  fechaFormateada = moment(creacion.toDate()).format("YYYY-MM-DD HH:mm:ss");
                } else if (creacion.seconds !== undefined) {
                  const fechaRegistro = new Date(creacion.seconds * 1000 + (creacion.nanoseconds || 0) / 1000000);
                  fechaFormateada = moment(fechaRegistro).format("YYYY-MM-DD HH:mm:ss");
                } else {
                  fechaFormateada = moment(creacion).format("YYYY-MM-DD HH:mm:ss");
                }
              }
            } catch (e) {
              fechaFormateada = "";
            }
            if (nuevoItem.registro) {
              nuevoItem.registro = { ...nuevoItem.registro, creacion: fechaFormateada };
            }
            return nuevoItem;
          })
        : [];
      const filtro = _.orderBy(revisiones, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      try {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.conductores.revisiones.registros,
          ),
          where("idConductor", "==", idConductor),
          where("registro.estado", "in", ["Creado", "Editado"]),
          orderBy("fecha", "desc"),
          orderBy("registro.creacion", "desc"),
          limit(1),
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
        if (data) {
          localforage.getItem(colecciones.localforage.seguridadVial.conductores.revisiones.registros).then((actuales) => {
            const lista = Array.isArray(actuales) ? actuales : [];
            const filtrados = lista.filter(item => item && item.id !== data.id);
            filtrados.push(data);
            localforage.setItem(colecciones.localforage.seguridadVial.conductores.revisiones.registros, filtrados);
          }).catch(e => console.warn("Error auto-guardando ultima revision conductor en local:", e));
        }
        return data;
      } catch (e) {
        console.warn("Falla de red en obtenerUltimaRevisionConductor, usando local:", e);
        return await this.obtenerUltimaRevisionConductor(idConductor, true);
      }
    }
  },
  async obtenerUltimaAptitudConductor(
    idConductor,
    idEmpresa,
    tipo,
    fecha,
    modoSinConexion,
  ) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.aptitudes.registros,
      );
      const aptitudes = registros
        ? registros
          .filter(
            (item) =>
              item.tipo === tipo &&
              item.idEmpresa === idEmpresa &&
              item.idConductor === idConductor &&
              item.registro.filtro === fecha,
          )
          .map((item) => {
            const nuevoItem = { ...item };
            nuevoItem.registro.creacion = moment(
              new Date(
                `${item.registro.realizacion.fecha} ${item.registro.realizacion.hora}`,
              ),
            ).format("YYYY-MM-DD HH:mm:ss");
            return {
              ...nuevoItem,
            };
          })
        : [];
      const filtro = _.orderBy(aptitudes, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.aptitudes.registros,
        ),
        where("tipo", "==", tipo),
        where("registro.filtro", "==", fecha),
        where("idConductor", "==", idConductor),
        where("idEmpresa", "==", idEmpresa),
        where("registro.estado", "in", ["Creado", "Editado"]),
        orderBy("registro.creacion", "desc"),
        limit(1),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
};
